export const JPEG_QUALITY = 0.6;
export const FILE_SIZE_THRESHOLD = 2000000;
export const ADD_INSURANCE = 'add-insurance';
export const PHOTO_ID_UPLOAD = 'photo-id-upload';
export const DECIDE_LATER_PHOTO_ID_UPLOAD = 'decide-later-photo-id-upload';
export const POST_PAYMENT_FINISH = 'finish-post-pay';
